import { styled } from "@linaria/react";
import * as React from "react";
import * as Icons from "react-feather";
const anchorize = (children?: React.ReactNode): undefined | string => {
  if (typeof children === "string") {
    return children.toLowerCase().replace(/[ _]+/g, "-").replace(/[!:^*./\\]/g, "");
  } else {
    return undefined;
  }
};
function Heading(Component: React.FunctionComponent<React.HTMLAttributes<HTMLHeadingElement>>) {
  return function Heading(props: React.HTMLAttributes<HTMLHeadingElement>) {
    const id = anchorize(props.children);
    return <Component id={id} {...props}>
        <a className={"a12hs2f7"} href={id && `#${id}`}>
          {props.children}
          <Icons.Link className={"c31avqb"} />
        </a>
      </Component>;
  };
}
export const h1 = /*#__PURE__*/styled('h1')({
  name: "h1",
  class: "h6ceq1b",
  propsAsIs: false
});
export const h2 = Heading( /*#__PURE__*/styled('h2')({
  name: "h2",
  class: "hj6166y",
  propsAsIs: false
}));
export const h3 = Heading( /*#__PURE__*/styled('h3')({
  name: "h3",
  class: "h1f8mqks",
  propsAsIs: false
}));
export const h4 = Heading( /*#__PURE__*/styled('h4')({
  name: "h4",
  class: "h1hmga4",
  propsAsIs: false
}));
export const blockquote = /*#__PURE__*/styled('blockquote')({
  name: "blockquote",
  class: "blrd6ep",
  propsAsIs: false
});
export const hr = /*#__PURE__*/styled('hr')({
  name: "hr",
  class: "h172su6f",
  propsAsIs: false
});
export const table = /*#__PURE__*/styled('table')({
  name: "table",
  class: "t1a7p0gg",
  propsAsIs: false
});
export const thead = /*#__PURE__*/styled('thead')({
  name: "thead",
  class: "t1fah8q4",
  propsAsIs: false
});
export const tbody = /*#__PURE__*/styled('tbody')({
  name: "tbody",
  class: "twrwqj6",
  propsAsIs: false
});
export const tr = /*#__PURE__*/styled('tr')({
  name: "tr",
  class: "t1fhygp",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => props => props.align || "center";
export const th = /*#__PURE__*/styled('th')({
  name: "th",
  class: "t176v8uh",
  propsAsIs: false,
  vars: {
    "t176v8uh-0": [_exp()]
  }
});
const _exp2 = /*#__PURE__*/() => props => props.align || "left";
export const td = /*#__PURE__*/styled('td')({
  name: "td",
  class: "tvhsmuz",
  propsAsIs: false,
  vars: {
    "tvhsmuz-0": [_exp2()]
  }
});
export const code = /*#__PURE__*/styled('code')({
  name: "code",
  class: "c197eb99",
  propsAsIs: false
});
export const a = /*#__PURE__*/styled('a')({
  name: "a",
  class: "a1d7vdmn",
  propsAsIs: false
});
export const p = /*#__PURE__*/styled('p')({
  name: "p",
  class: "pgfnift",
  propsAsIs: false
});
export const ul = /*#__PURE__*/styled('ul')({
  name: "ul",
  class: "u3pt2dg",
  propsAsIs: false
});
export const ol = /*#__PURE__*/styled('ol')({
  name: "ol",
  class: "ojr9iky",
  propsAsIs: false
});

require("./components.linaria.module.css!=!../../../../../node_modules/.pnpm/@linaria+webpack5-loader@5.0.4_webpack@5.91.0/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./components.tsx");